import React, { useContext, useState } from "react";
import { LayoutContext } from "../../hooks/layout-context";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import usePartners from "../../hooks/use-partners";
import { Partner } from "../../types/partner";
import PartnerForm from '../../components/forms/partner-form';

export default function PartnerEdit() {
  const { t } = useTranslation();
  const { layout, setLayout } = useContext(LayoutContext);
  const params = useParams();
  const { getById } = usePartners();
  const [partner, setPartner] = useState<Partner | null>();

  React.useEffect(() => {
    if (params !== undefined && params !== null) {
      if (params.id !== undefined && params.id !== null) {
        (async () => {
          const result = await getById(params.id!!);
          setPartner(result);
        })();
      }
    }
  }, []);

  React.useEffect(() => {
    layout.sideMenu = "partners";
    layout.showSearch = false;
    layout.breadcrumbs = [
      { label: t("Oddziały"), path: "/partners" },
      { path: null, label: t("Edytuj") },
    ];
    setLayout({ ...layout });
  }, []);

  return partner !== undefined && partner !== null ? (
    <PartnerForm id={params.id || null} partner={partner} />
  ) : (
    <></>
  );
}
